var exports = {
  "e": "MonaHead__cARNFC",
};

module.exports = exports;
